import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";

/** Cached public platform config (fees + feature flags). One fetch per session. */
let cache = null;
let inflight = null;

export function fetchPlatformConfig() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios
      .get(`${API}/platform/config`)
      .then((r) => {
        cache = r.data || {};
        return cache;
      })
      .catch(() => ({}))
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function usePlatformConfig() {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => {
    let alive = true;
    fetchPlatformConfig().then((c) => alive && setCfg(c));
    return () => {
      alive = false;
    };
  }, []);
  return cfg || {};
}
